import gql from 'graphql-tag';

const GET_MATERIAL =  gql`
  query GetMystageMaterials($b: Int!, $test: Int!) {
    mystage_get_materials(b: $b, test: $test) {
      ri
      lv
      rk
      rt
      mt
      ls {
        li
        ln
        lc
        lt
        ti
        vi
        mi
        hh
        rv
      }
    }
  }
`;

const GET_PDF = gql`
  query GetPdf($b: Int!, $m: Int!, $dl: Int!) {
    get_pdf(b: $b, m: $m, dl: $dl) {
      id
      type
      url
    }
  }
`;

const GET_HTML = gql`
  query getHtml($l: Int!, $r: Int!, $b: Int!, $sm: Int!, $p: Int, $rv: Int) {
    get_html(l: $l, r: $r, b: $b, sm: $sm, p: $p, rv: $rv) {
      id
      program_id
      level_id
      rank_id
      lesson_id
      code
      no
      title
      program
      level
      rank
      css
      content
      pdf_url
      html_url
      is_revamp
      admin
    }
  }`;

export { GET_MATERIAL, GET_PDF, GET_HTML };
